const projects = [
  {
    id: 1,
    titleKey: 'sections.projects.preventing_ddos_attacks.title',
    subtitleKey: 'sections.projects.preventing_ddos_attacks.subtitle',
    slug: 'preventing-ddos-attacks',
    detailsLink: '/portfolio/preventing-ddos-attacks',
    detailsImage: 'assets/img/project/project_single_01.jpg',
    img: 'assets/img/project/project_1_1.jpg',
  },
  {
    id: 2,
    titleKey: 'sections.projects.protecting_digital_frontiers.title',
    subtitleKey: 'sections.projects.protecting_digital_frontiers.subtitle',
    slug: 'protecting-digital-frontiers',
    detailsLink: '/portfolio/protecting-digital-frontiers',
    detailsImage: 'assets/img/project/project_single_02.jpg',
    img: 'assets/img/project/project_1_2.jpg',
  },
  {
    id: 3,
    titleKey: 'sections.projects.ethical_hacking_defense.title',
    subtitleKey: 'sections.projects.ethical_hacking_defense.subtitle',
    slug: 'ethical-hacking-defense',
    detailsLink: '/portfolio/ethical-hacking-defense',
    detailsImage: 'assets/img/project/project_single_03.jpg',
    img: 'assets/img/project/project_1_3.jpg',
  },
  {
    id: 4,
    titleKey: 'sections.projects.preventing_ddos_attacks.title',
    subtitleKey: 'sections.projects.preventing_ddos_attacks.subtitle',
    slug: 'preventing-ddos-attacks-2',
    detailsLink: '/portfolio/preventing-ddos-attacks-2',
    detailsImage: 'assets/img/project/project_single_04.jpg',
    img: 'assets/img/project/project_1_4.jpg',
  },
  {
    id: 5,
    titleKey: 'sections.projects.protecting_digital_frontiers.title',
    subtitleKey: 'sections.projects.protecting_digital_frontiers.subtitle',
    slug: 'protecting-digital-frontiers-2',
    detailsLink: '/portfolio/protecting-digital-frontiers-2',
    detailsImage: 'assets/img/project/project_single_05.jpg',
    img: 'assets/img/project/project_1_5.jpg',
  },
  {
    id: 6,
    titleKey: 'sections.projects.ethical_hacking_defense.title',
    subtitleKey: 'sections.projects.ethical_hacking_defense.subtitle',
    slug: 'ethical-hacking-defense-2',
    detailsLink: '/portfolio/ethical-hacking-defense-2',
    detailsImage: 'assets/img/project/project_single_06.jpg',
    img: 'assets/img/project/project_1_6.jpg',
  },
  {
    id: 7,
    titleKey: 'sections.projects.preventing_ddos_attacks.title',
    subtitleKey: 'sections.projects.preventing_ddos_attacks.subtitle',
    slug: 'preventing-ddos-attacks-3',
    detailsLink: '/portfolio/preventing-ddos-attacks-3',
    detailsImage: 'assets/img/project/project_single_07.jpg',
    img: 'assets/img/project/project_1_7.jpg',
  },
  {
    id: 8,
    titleKey: 'sections.projects.protecting_digital_frontiers.title',
    subtitleKey: 'sections.projects.protecting_digital_frontiers.subtitle',
    slug: 'protecting-digital-frontiers-3',
    detailsLink: '/portfolio/protecting-digital-frontiers-3',
    detailsImage: 'assets/img/project/project_single_08.jpg',
    img: 'assets/img/project/project_1_8.jpg',
  },
  {
    id: 9,
    titleKey: 'sections.projects.ethical_hacking_defense.title',
    subtitleKey: 'sections.projects.ethical_hacking_defense.subtitle',
    slug: 'ethical-hacking-defense-3',
    detailsLink: '/portfolio/ethical-hacking-defense-3',
    detailsImage: 'assets/img/project/project_single_09.jpg',
    img: 'assets/img/project/project_1_9.jpg',
  }
];

export default projects;
